import { useAppSelector } from '@hooks/app/redux';
import { memberApiV2 } from '@lib/api';
import { AsyncSelect, AsyncSelectProps } from '../../ui/inputs/select';
import React from 'react';
import { useIntl } from 'react-intl';
import { OptionTypeBase } from 'react-select';
import { getSoftwareMerchants } from '@services/external/software-provider.api';
import { default as SelectBase } from 'react-select/async';

interface ExpertiseSelectProps
  extends Omit<
    AsyncSelectProps<OptionTypeBase, false>,
    'loadOptions' | 'placeholder' | 'isMulti' | 'cacheOptions' | 'defaultOptions'
  > {}

const SoftwareProvidersSelect = (
  props: ExpertiseSelectProps,
  ref?: React.Ref<SelectBase<any, any>>,
) => {
  const { formatMessage } = useIntl();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  const institutionOpts = React.useCallback(
    async (query: string) => {
      const providers = (
        await getSoftwareMerchants(providerId, {
          page: 1,
          pageSize: 30,
          sortBy: 'name',
          direction: 'ASC',
          // @ts-expect-error no BE yet
          text: query,
        })
      ).data;

      return providers.data.items.map((e) => ({
        value: e.id,
        label: e.name,
      }));
    },
    [providerId],
  );

  return (
    <AsyncSelect
      ref={ref}
      loadOptions={institutionOpts}
      isMulti={false}
      cacheOptions
      defaultOptions
      placeholder={formatMessage({ id: 'rs_placeholder' })}
      isSearchable={false}
      {...props}
    />
  );
};

export default React.forwardRef(SoftwareProvidersSelect);
